import get from 'lodash/get';
import { date } from '../../utils';

export function mapSubscriptions({ data, loading, error }) {
  if (loading || error) {
    return { data: [], loading, error };
  }

  try {
    return {
      data: data.userPayments.edges.map(edge => ({
        username: get(edge, 'node.user.username'),
        email: edge.node.currentUserEmail,
        amount: `$${edge.node.amount}`,
        paymentDate: date.lastUpdated(edge.node.createdAt),
        payee: get(edge, 'node.payee.username'),
        status: edge.node.status,
        checkNumber: edge.node.checkNumber,
        cancelReason: edge.node.cancelReason,
        ...get(edge, 'node.user', {}),
        uuid: edge.node.uuid,
      })),
      loading,
      error,
      totalCount: data.userPayments.totalCount,
    };
  } catch (mapError) {
    return { data: [], loading, error: mapError };
  }
}

export function mapPaymentsDue({ data, loading, error }) {
  if (loading || error) {
    return { data: [], loading, error };
  }

  try {
    return {
      data: data.paymentsDue.edges.map(edge => ({
        amount: `$${edge.node.amount}`,
        ...get(edge, 'node.user', {}),
      })),
      loading,
      error,
      totalCount: data.paymentsDue.totalCount,
    };
  } catch (mapError) {
    return { data: [], loading, error: mapError };
  }
}

export default {
  mapSubscriptions,
  mapPaymentsDue,
};
